import React, { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { buildCommunityHeaderProps } from 'modules/posts/routes/ResourceHeaders/community_header'

const RootPage = React.lazy(() => import('modules/posts/pages/PostsRootPage'))
const CommunitiesFeatureFlagGuard = React.lazy(
  () => import('modules/posts/pages/CommunitiesFeatureFlagGuard')
)
const ShowCommunityPage = lazy(() => import('modules/posts/pages/ShowCommunityPage'))

export const postsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.communities.path,
      element: (
        <CommunitiesFeatureFlagGuard>
          <RootPage />
        </CommunitiesFeatureFlagGuard>
      ),
      handle: {
        module: 'kudos', // TODO: Change to communities when F0 with communities is ready
        moduleName: () => i18n.t('posts.communities.communities_title'),
      },
      children: [
        {
          index: true,
          element: <ShowCommunityPage />,
        },
        {
          path: navigation.communities.id.path,
          children: [
            {
              index: true,
              element: <ShowCommunityPage />,
            },
          ],
        },
      ],
    },
  ]
}
